import {
  ADD_VIDEO_UPLOAD_CONFIG,
  ADD_VIDEO_FILE_NAME,
  TOGGLE_VIDEO_UPLOAD_SUCCESS,
} from '../constants';

export function videoUpload(state = {}, action) {
  switch (action.type) {
    case ADD_VIDEO_UPLOAD_CONFIG:
      return action.videoUpload;
    default:
      return state;
  }
}

export function videoFileName(state = '', action) {
  switch (action.type) {
    case ADD_VIDEO_FILE_NAME:
      return action.fileName;
    default:
      return state;
  }
}

export function videoUploadSuccessful(state = false, action) {
  switch (action.type) {
    case TOGGLE_VIDEO_UPLOAD_SUCCESS:
      return action.toggle;
    default:
      return state;
  }
}
